import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { BootstrapVue } from 'bootstrap-vue';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import VueLocalForage from 'vue-localforage';
import { longClickDirective } from 'vue-long-click';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import locales from '@/assets/JS/locales.js'


delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

Vue.use(BootstrapVue);
Vue.use(VueLocalForage);
Vue.use(VueI18Next);

const longClickInstance = longClickDirective({delay: 3000, interval: 0})
Vue.directive('longclick', longClickInstance)

Vue.config.productionTip = false


i18next.init({
  lng: 'en',
  whitelist: ['en', 'es'],
  resources: {
    en: { translation: locales.en },
    es: { translation: locales.es }
  }
});

const i18n = new VueI18Next(i18next);

new Vue({
  router,
  store,
  i18n: i18n,
  render: h => h(App)
}).$mount('#app')
